export default __webpack_public_path__ + "sketch.d0c2e9fd.png";